import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";

interface LinkButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, RouteComponentProps {
  to: string;
};

const PLinkButton: React.FC<LinkButtonProps> = ({
  history, location, match, staticContext,
  to, ...buttonProps
}) => <button {...buttonProps} onClick={_ => history.push(to)} />

export const LinkButton = withRouter(PLinkButton);
